<template>
    <Page :header="header[lang].name" :header_pos="'center'">
        <template #body>
            <div class="flex justify-content-center flex-wrap card-container">
                <AuthTgButton />

                <Divider align="center" type="dotted">
                    <span class="text-500">{{ header[lang].or }}</span>
                </Divider>
                
                <RegForm :redirect_url="redirect_url"/>

                <Divider />
                
                <div class="w-full">
                    <div class="flex justify-content-center flex-wrap card-container yellow-container">
                        <div class="flex align-items-center justify-content-center w-full m-2 gap-2">
                            <Button :label="buttons[lang].sign_in" @click="go_auth" text severity="info"/>
                            <Button :label="buttons[lang].forgot_password" @click="go_pass" text severity="info"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect      from    '@/assets/js/Connect'
import Helper       from    '@/assets/js/Helper'
import Event        from    '@/assets/js/Event'
import Page         from    '@/components/sides/Page.vue'
import AuthTgButton from    '@/components/widgets/AuthTgButton.vue' 
import RegForm      from    '@/components/public/registration/RegForm.vue' 
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: {
                    name: "Registration",
                    or: "or",
                } ,
                ru: {
                    name: "Регистрация",
                    or: "или",
                } ,
            },
            buttons:  {
                en:{
                    sign_in : "Sign In",
                    registation: "Registration",
                    forgot_password: "Forgot password",
                },
                ru:{
                    sign_in : "Войти",
                    registation: "Регистрация",
                    forgot_password: "Забыл пароль",
                }                 
            },
        }
    },
    components: {
        Page,
        RegForm,
        AuthTgButton
    },
    watch: {},
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        go_auth() {
            this.event.send('loginBtn')
            this.$router.push({path: '/auth/'})
        },
        go_pass() {
            this.event.send('forgotBtn')
            this.$router.push({path: '/pass/'})
        },
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isAuth: function () { return this.$store.getters.isAuthenticated },
    },
    async beforeCreate () {
        this.connect = new Connect(this)
        this.helper = new Helper()
        this.event = new Event()

        // определим параметр redirect_url
        if(this.$route.query && this.$route.query.redirect_url) {
            this.redirect_url = this.$route.query.redirect_url
        }
    },
    mounted(){
        if(this.isAuth) this.$router.push({ path: '/' })
        
        try {
            this.SetHeaderTitle(null)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/auth/',
                label: this.buttons[this.lang].sign_in,
                icon: 'pi pi-sign-in',
                iconPos: 'right',
                severity: 'secondary',
                class: '',
                rounded: true,
                visible: true
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>